// component can be reworked in order to accept any empty state (e.g feedback)
import EmptyPage from './empty-page-state'

export default EmptyPage
